import { render, staticRenderFns } from "./OfficialWebsite.vue?vue&type=template&id=54a7131c&scoped=true"
import script from "./OfficialWebsite.vue?vue&type=script&lang=js"
export * from "./OfficialWebsite.vue?vue&type=script&lang=js"
import style0 from "./OfficialWebsite.vue?vue&type=style&index=0&id=54a7131c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7131c",
  null
  
)

export default component.exports